/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { selectNewStyle, checkArray } from '../../../../Components/helper';
import { useProductInformationState } from '../Provider';
import ProductCardList from './ProductCardList';
import { getProductReorderDetail } from '../../store/DevelopmentOrder.action';
import { fetchRightsAssignmentAction } from '../../../Supplier/store/Supplier.action';
import Chat from '../../../Chat/Chat';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';
import { swapClusterRow } from './clusterRow';
import './product-card.css';
import { captureClusterParent } from './clusterOptionLabel';

function ProductListContainer() {
  const reducer = useSelector((reducerState) => reducerState);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const { ProductListData, Users, UserDetails } = reducer;
  const { state, setState, callGetDevorderListApi, hasMore } = useProductInformationState();
  const { productGroups } = ProductListData;
  const { sectionAccess } = Users;
  const { isSupplierLoggedIn, userInfo } = UserDetails;
  const ProductGroupToggle = sectionAccess?.masters?.productGroupsAccess;
  const { pageIndex, productData, searchText, filterData, filterSort, activeList, isSelectAll, pageLoading, selectedGroupId, scrollLoader, selectedGroup } =
    state;
  const [userRightsAssignment, setUserRightsAssignment] = useState(null);

  const getDevOrderList = async (index, isScrolled = false) => {
    const payloadObj = {
      archived: !!['archived', 'bin'].includes(activeList),
      count: index,
      searchText,
      isScrolled,
      deleted: !!['bin'].includes(activeList),
      ...filterData,
      ...filterSort,
    };
    if (selectedGroupId) {
      payloadObj.groupId = selectedGroupId;
    }

    await callGetDevorderListApi(payloadObj);
  };

  const handleNextPagesInScroll = () => {
    let index = pageIndex;
    index += 20;
    setState((prevData) => ({
      ...prevData,
      scrollLoader: true,
      pageIndex: index,
    }));
    getDevOrderList(index, true);
  };
  const onSelectAll = () => {
    if (checkArray(productData) && !isSelectAll) {
      const ids = productData?.map((ele) => {
        return ele?.clusterId ? ele.clusterId : ele._id;
      });
      setState((prevData) => ({
        ...prevData,
        isSelectAll: !isSelectAll,
        selectedIds: [...(prevData?.selectedIds || []), ...ids],
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        isSelectAll: !isSelectAll,
        selectedIds: [],
      }));
    }
  };

  const handleFilterProductGroup = async (val) => {
    setState((prevData) => ({
      ...prevData,
      productData: [],
      selectedGroupId: val?._id,
      pageIndex: 0,
      pageLoading: true,
      selectedGroup: val,
    }));
    await callGetDevorderListApi({
      archived: false,
      count: 0,
      groupId: val?._id,
      searchText,
      ...filterData,
      ...filterSort,
    });
  };

  useEffect(() => {
    const fetchUserRights = async () => {
      if (isSupplierLoggedIn && userInfo?.userId) {
        try {
          const rightsAssignment = await dispatch(fetchRightsAssignmentAction({ userId: userInfo.userId }));
          setUserRightsAssignment(rightsAssignment);
        } catch (error) {
          console.error('Failed to fetch user rights:', error);
        }
      }
    };
    fetchUserRights();
  }, [isSupplierLoggedIn, userInfo?.userId, dispatch]);

  const filteredProductData = useMemo(() => {
    if (!isSupplierLoggedIn) {
      return productData;
    }

    if (!productData || productData.length === 0) {
      return productData;
    }

    if (!userRightsAssignment) {
      return productData;
    }

    const { brands, subBrands, typeOneCategories, typeTwoCategories, productTypes } = userRightsAssignment;

    if (brands === true && typeOneCategories === true && typeTwoCategories === true) {
      return productData;
    }

    return productData.filter((product) => {
      let passedFilters = true;

      const getId = (field) => {
        if (!field) return null;
        return typeof field === 'object' ? field._id : field;
      };

      const getName = (field) => {
        if (!field) return null;
        return typeof field === 'object' ? field.name : field;
      };

      if (brands !== true && brands && brands?.length > 0) {
        const productBrandId = getId(product?.brand);
        const productBrandName = getName(product?.brand);

        const brandMatch = brands?.some((brandId) => brandId === productBrandId || brandId === productBrandName);

        if (!productBrandId || !brandMatch) {
          passedFilters = false;
        }
      }

      if (passedFilters && subBrands && subBrands !== true && Array.isArray(subBrands) && subBrands.length > 0) {
        const productSubBrandId = getId(product.subBrand);
        const productSubBrandName = getName(product.subBrand);

        if (productSubBrandId || productSubBrandName) {
          const subBrandMatch = subBrands.some((subBrandId) => subBrandId === productSubBrandId || subBrandId === productSubBrandName);
          if (!subBrandMatch) {
            passedFilters = false;
          }
        }
      }
      if (passedFilters && typeOneCategories !== true && typeOneCategories && typeOneCategories.length > 0) {
        const productCat1Id = getId(product?.category1) || product?.catOne;
        const productCat1Name = getName(product?.category1) || product?.catOne;

        const cat1Match = typeOneCategories?.some((catId) => catId === productCat1Id || catId === productCat1Name);

        if (!productCat1Id || !cat1Match) {
          passedFilters = false;
        }
      }

      if (passedFilters && typeTwoCategories !== true && typeTwoCategories && typeTwoCategories.length > 0) {
        const productCat2Id = getId(product?.category2) || product?.catTwo;
        const productCat2Name = getName(product?.category2) || product?.catTwo;

        const cat2Match = typeTwoCategories?.some((catId) => catId === productCat2Id || catId === productCat2Name);

        if (!productCat2Id || !cat2Match) {
          passedFilters = false;
        }
      }

      if (passedFilters && productTypes && productTypes !== true && Array.isArray(productTypes) && productTypes.length > 0) {
        const productTypeId = getId(product.productType);
        const productTypeName = getName(product.productType);

        if (productTypeId || productTypeName) {
          const typeMatch = productTypes.some((typeId) => typeId === productTypeId || typeId === productTypeName);
          if (!typeMatch) {
            passedFilters = false;
          }
        }
      }

      return passedFilters;
    });
  }, [isSupplierLoggedIn, userRightsAssignment, productData]);

  const productGroupOptions = useMemo(() => {
    if (checkArray(productGroups)) {
      return productGroups;
    }
    return [];
  }, [productGroups]);

  const getReorderData = async (devId, index) => {
    const reorderData = await dispatch(getProductReorderDetail({ productId: devId }));
    if (!reorderData?.data) return;
    setState((prevData) => {
      const clusterRow = prevData?.productData?.[index];
      const nextRow = swapClusterRow(clusterRow, reorderData.data, devId);
      if (!nextRow) return prevData;
      const nextProductData = [...prevData.productData];
      nextProductData[index] = { ...nextRow, clusterParent: captureClusterParent(clusterRow) };
      return { ...prevData, productData: nextProductData };
    });
  };
  return (
    <Container id="scrollableContaier_productList" className="sticky-header-inner-scroll" fluid>
      {activeList !== 'bin' ? (
        <div className="product-group-filter">
          {!isSupplierLoggedIn && checkArray(productData) && (
            <div className="d-inline-flex align-items-center">
              <NewCheckbox
                aria-label="Select All"
                checked={isSelectAll}
                onChange={() => onSelectAll()}
                label="Select All"
                labelClassName="text-bold"
              />
            </div>
          )}
          {activeList === 'open' && ProductGroupToggle && (
            <div className="w-300 xs-w-200  mb-2 mb-md-0 ml-16 d-none">
              <Select
                options={productGroupOptions}
                isClearable
                classNamePrefix="common-select"
                onChange={(e) => handleFilterProductGroup(e)}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                styles={selectNewStyle}
                placeholder={t('FILTER.SELECT_PRODUCT_GROUP')}
                value={selectedGroup}
              />
            </div>
          )}
        </div>
      ) : (
        <div style={{ paddingTop: 10 }} />
      )}
      {pageLoading ? (
        <Loader />
      ) : (
        <>
          {filteredProductData?.length > 0 && (
            <InfiniteScroll
              dataLength={filteredProductData?.length}
              next={handleNextPagesInScroll}
              hasMore={hasMore}
              loader={scrollLoader && <Loader />}
              style={{ paddingBottom: 103 }}
              scrollableTarget="scrollableContaier_productList"
            >
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1440: 4, 1600: 5 }}>
                <Masonry className="custom-masonry" gutter="30px">
                  {filteredProductData?.map((ele, i) => (
                    <ProductCardList key={i} item={ele} index={i} getReorderData={getReorderData} isEditIconVisible={activeList === 'open'} />
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            </InfiniteScroll>
          )}
          {!pageLoading && filteredProductData?.length === 0 && (
            <Row>
              <Col md="12">
                <p className="f-16 text-medium justify-content-center align-item-center d-flex">{t('FILTER.CURRENT_MESSAGE')}</p>
              </Col>
            </Row>
          )}
        </>
      )}
      {(userInfo?.role === 'User' || userInfo?.role === 'Admin') && (
        <Chat moduleKey="ProductInfoList" isDetailsPage={false} currentUser={userInfo} activeTab={null} />
      )}
    </Container>
  );
}

export default ProductListContainer;
